import "./helpers/sentry";

import { Livewire } from "@livewire";
Livewire.start();

// Workarounds for various browser specific issues
import "./quirks/facebook";
import "./quirks/bing-with-adblocker";
import "./quirks/storage";

// Load LuxSwiper and make it global
import { swiperScroll, swiperSlider } from "./classes/lux-swiper/LuxSwiper";
window.swiperScroll = swiperScroll;
window.swiperSlider = swiperSlider;

import { Reorder } from "./classes/Reorder";
window.Reorder = Reorder;

import { Search } from "./classes/Search";
window.Search = Search;

import { MembershipOffer } from "./classes/MembershipOffer";
window.MembershipOffer = MembershipOffer;

import { LuxNotifications } from "./classes/notifications/LuxNotifications";
window.LuxNotifications = LuxNotifications;

import { LuxPDQ } from "./classes/pdq/LuxPDQ";
window.LuxPDQ = LuxPDQ;

// Load global helpers
import "./helpers/lazy-loader";
import "./helpers/misc";

import {
    validateEmailSimple,
    validateEmail,
    validateEmailRegex,
} from "./helpers/utils";
window.validateEmailSimple = validateEmailSimple;
window.validateEmail = validateEmail;
window.validateEmailRegex = validateEmailRegex;

import "./helpers/header_b";

import { registerAutoOpenFromUrl } from "./helpers/dom-manipulation/dom-manipulation";
registerAutoOpenFromUrl();
// ?visit=<id> auto-clicks a plain link (e.g. a marketing link straight to a
// page), as opposed to ?open=<id> above which opens a popup.
registerAutoOpenFromUrl({
    selector: '[data-toggle="lux-link"]',
    param: "visit",
    prefix: "",
});

// Load all application components
import "./components/address-validation";
import "./components/basket";
import "./components/customer-visit";
import "./components/first-time-visitor";
import "./components/lux-accordions";
import "./components/lux-dropdown";
import "./components/lux-expandable";
import "./components/lux-popup";
import "./components/lux-popups/account-menu";
import "./components/lux-scroll";

if (document.querySelector(".lux-select-dropdown")) {
    import("./components/lux-select.js").then(({ default: luxSelect }) => {
        luxSelect.initializeCustomSelect();
    });
}

import "./components/lux-tabs";
import "./components/lux-tooltips";
import "./components/lux-sidebar";
import "./components/order";
import "./components/shrinking-navigation-bar";
import "./components/rate-product-item";

if (import.meta.hot) {
    import.meta.hot.accept();
}
